<template>
  <div v-if="shouldShow" class="bubble-evaluate">
    <span class="bubble-evaluate__label">Helpful?</span>
      <svg v-if="isHelpful" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="good-thumb">
          <path
            id="Vector"
            d="M1.39642 7.39118C1.36255 7.00165 1.6696 6.66675 2.06058 6.66675H3.33342C3.70162 6.66675 4.00009 6.96521 4.00009 7.33341V13.6667C4.00009 14.0349 3.70162 14.3334 3.33342 14.3334H2.6113C2.2655 14.3334 1.9771 14.069 1.94714 13.7245L1.39642 7.39118Z"
            fill="#8B8B8B"
            stroke="#8B8B8B"
            stroke-width="0.666667"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            id="Vector_2"
            d="M6 7.12492C6 6.84635 6.17313 6.59701 6.4251 6.47825C6.9746 6.21921 7.91097 5.69802 8.33333 4.99358C8.8777 4.08572 8.98037 2.4454 8.99707 2.06967C8.9994 2.01708 8.9979 1.96442 9.00513 1.91227C9.09537 1.26157 10.3514 2.02172 10.8333 2.82545C11.0949 3.26165 11.1284 3.83475 11.1009 4.28218C11.0715 4.76092 10.9311 5.22338 10.7934 5.68285L10.5 6.66158H14.119C14.5611 6.66158 14.8807 7.08401 14.7605 7.50945L12.9704 13.8479C12.8893 14.1351 12.6273 14.3334 12.3289 14.3334H6.66667C6.29847 14.3334 6 14.0349 6 13.6667V7.12492Z"
            fill="#8B8B8B"
            stroke="#8B8B8B"
            stroke-width="0.666667"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </svg>
      <svg v-else width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="bad-thumb">
          <path
            id="Vector"
            d="M14.6036 8.60882C14.6375 8.99835 14.3304 9.33325 13.9394 9.33325H12.6666C12.2984 9.33325 11.9999 9.03479 11.9999 8.66659V2.33325C11.9999 1.96505 12.2984 1.66658 12.6666 1.66658H13.3887C13.7345 1.66658 14.0229 1.93098 14.0529 2.27548L14.6036 8.60882Z"
            fill="#8B8B8B"
            stroke="#8B8B8B"
            stroke-width="0.666667"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            id="Vector_2"
            d="M10 8.87508C10 9.15365 9.82687 9.40299 9.5749 9.52175C9.0254 9.78079 8.08903 10.302 7.66667 11.0064C7.1223 11.9143 7.01963 13.5546 7.00293 13.9303C7.0006 13.9829 7.0021 14.0356 6.99487 14.0877C6.90463 14.7384 5.64857 13.9783 5.16667 13.1745C4.90513 12.7383 4.8716 12.1653 4.8991 11.7178C4.92853 11.2391 5.0689 10.7766 5.2066 10.3172L5.5 9.33842H1.88103C1.43893 9.33842 1.1193 8.91599 1.23947 8.49055L3.02957 2.15205C3.11067 1.86489 3.37273 1.66658 3.67113 1.66658H9.33333C9.70153 1.66658 10 1.96505 10 2.33325V8.87508Z"
            fill="#8B8B8B"
            stroke="#8B8B8B"
            stroke-width="0.666667"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </svg>
  </div>
</template>

<script>
/**
 * 气泡底部评价组件
 * @prop {Object} message - 消息对象，需包含 additional_attributes.ub_user_evaluate_helpful 字段
 */
export default {
  name: 'BubbleEvaluate',
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
  computed: {
    shouldShow() {
      return (
        this.message &&
        this.message.additional_attributes &&
        this.message.additional_attributes.ub_user_evaluate_helpful !== undefined
      );
    },
    isHelpful() {
      return this.message.additional_attributes.ub_user_evaluate_helpful === 1;
    },
  },
};
</script>

<style scoped>
.bubble-evaluate {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 13px;
  color: #888;
  margin-top: 4px;
  margin-right: calc(1.5rem + 16px);
  justify-content: flex-end;
}
.bubble-evaluate__label {
  margin-right: 2px;
  font-size: 11px;
  color: rgba(0, 0, 0, 0.60);
}
.bubble-evaluate__icon svg {
  display: inline-block;
  vertical-align: middle;
}
</style> 